<template>
  <div class="legal-link-container" @click="changeOpenInfo">
    <a class="legal-link">{{getCheckLegalTrans.title}}</a>
    <div class="legal-icon">
      <PlusIcon v-if="!openInfo" />
      <MinusIcon v-if="openInfo" />
    </div>
  </div>
  <div
    class="legal-info-container"
    :class="{
      hidden: !openInfo
    }"
  >
    <p><b>{{getCheckLegalTrans.p1_b}}</b> S.A. DAMM <a class="cursor-pointer" @click="openPolicy">(+ {{getCheckLegalTrans.p1_link}})</a></p>
    <p><b>{{getCheckLegalTrans.p2_b}}</b>{{getCheckLegalTrans.p2}}</p>
    <p><b>{{getCheckLegalTrans.p3_b}}</b>{{getCheckLegalTrans.p3}}</p>
    <p><b>{{getCheckLegalTrans.p4_b}}</b>  S.A. DAMM</p>
    <p><b>{{getCheckLegalTrans.p5_b}}</b> {{getCheckLegalTrans.p5}}</p>
    <p>{{getCheckLegalTrans.p6}} <a href="mailto:privacidad@damm.com">PRIVACIDAD@DAMM.COM</a></p>
    <p>{{getCheckLegalTrans.p7}}<a class="cookies-link" href="https://www.agpd.es" target="_blank" rel="noopener noreferrer">(WWW.AGPD.ES)</a></p>
    <p><b>{{getCheckLegalTrans.p8_b}}</b> {{getCheckLegalTrans.p8}} <a class="cursor-pointer" @click="openPolicy">{{getCheckLegalTrans.p8_here}}</a> </p>
  </div>
  <div class="legal-checkbox">
    <LegalCheckbox
      v-model="acceptLegal"
      :label="getCheckLegalTrans.checkbox_title"
      :modelOpen="openInfo"
      @updateModelOpen="onUpdateModelOpen"
    />
  </div>
</template>

<script>

import PlusIcon from '@/components/PlusIcon.vue'
import MinusIcon from '@/components/MinusIcon.vue'
import LegalCheckbox from '@/components/LegalCheckbox.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'CheckLegal',
  data () {
    return {
      openInfo: false
    }
  },
  components: {
    PlusIcon,
    MinusIcon,
    LegalCheckbox
  },
  computed: {
    ...mapState(['acceptLegal']),
    ...mapGetters(['getCheckLegalTrans'])
  },
  methods: {
    changeOpenInfo () {
      this.openInfo = !this.openInfo
    },
    onUpdateModelOpen (value) {
      this.openInfo = value
    },
    openPolicy () {
      window.open(`https://participa.barmanagerapp.com/keler/#/${this.$route.params.alias_url}/policy`, '_blank')
    }
  }
}
</script>

<style scoped>
.legal-link-container {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin-top: 1.5rem;
}
.legal-link {
  font-size: 1rem;
  line-height: 1.5rem;
  padding-left: 0.25rem;
}
.legal-icon {
  --tw-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--tw-border-opacity));
  border-width: 1px;
  display: inline;
  margin-right: 0.25rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.legal-info-container {
  font-size: 0.875rem;
  line-height: 1.25rem;
  max-height: 250px;
  overflow: auto;
  padding-top: 0.5rem;
  text-align: left;
}
.legal-info-container.hidden {
  display: none;
}
.legal-info-container p {
  padding: 0.25rem;
}
.legal-info-container a {
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
.legal-checkbox {
  margin-left: 0.25rem;
  margin-top: 1rem;
}
</style>
